// extracted by mini-css-extract-plugin
module.exports = {"focus":"FileInput_focus__gfQsb"};